export const sliderData = [
    {
        img: "https://png.pngtree.com/png-vector/20191120/ourmid/pngtree-training-course-online-computer-chat-flat-color-icon-vector-png-image_2007114.jpg",
        title: ""
    },
    {
        img: "https://png.pngtree.com/png-clipart/20220131/original/pngtree-web-site-department-programmers-and-art-department-create-a-company-website-png-image_7258173.png",
        title: ""
    },
    {
        img: "https://static.vecteezy.com/system/resources/thumbnails/008/846/307/small/online-courses-with-students-sitting-on-books-pile-with-laptops-notebooks-png.png",
        title: ""
    },
    {
        img: "https://img.pikbest.com/png-images/online-course-learning-at-home_1739194.png!w700wp",
        title: ""
    },
    {
        img: "https://static.vecteezy.com/system/resources/previews/022/593/842/original/business-training-course-free-png.png",
        title: ""
    }
]

export const revData = [
  {
    username: 'Sarah Johnson',
    img: 'https://via.placeholder.com/150?text=Sarah',
    rev: 'This platform transformed my coding skills! The React course was clear, engaging, and packed with practical examples.',
    rating: 5,
  },
  {
    username: 'Michael Chen',
    img: 'https://via.placeholder.com/150?text=Michael',
    rev: 'The video lectures are top-notch. I learned DSA concepts quickly and applied them in real projects.',
    rating: 4,
  },
  {
    username: 'Emily Davis',
    img: 'https://via.placeholder.com/150?text=Emily',
    rev: 'Amazing community and resources! The courses are well-structured, but I wish there were more quizzes.',
    rating: 4,
  },
  {
    username: 'James Patel',
    img: 'https://via.placeholder.com/150?text=James',
    rev: 'The best learning platform I’ve used. The instructors are knowledgeable, and the content is up-to-date.',
    rating: 5,
  },
    {
    username: 'Sarah Johnson',
    img: 'https://via.placeholder.com/150?text=Sarah',
    rev: 'This platform transformed my coding skills! The React course was clear, engaging, and packed with practical examples.',
    rating: 5,
  },
  {
    username: 'Michael Chen',
    img: 'https://via.placeholder.com/150?text=Michael',
    rev: 'The video lectures are top-notch. I learned DSA concepts quickly and applied them in real projects.',
    rating: 4,
  },
  {
    username: 'Emily Davis',
    img: 'https://via.placeholder.com/150?text=Emily',
    rev: 'Amazing community and resources! The courses are well-structured, but I wish there were more quizzes.',
    rating: 4,
  },
  {
    username: 'James Patel',
    img: 'https://via.placeholder.com/150?text=James',
    rev: 'The best learning platform I’ve used. The instructors are knowledgeable, and the content is up-to-date.',
    rating: 5,
  },
];